import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box, Paper, Stack, TextField, Button, Typography, Alert, CircularProgress, Avatar, Container,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import { validarReset, redefinirSenha } from "../../services/candidatoService";

export default function RedefinirSenha() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [valido, setValido] = useState(null); // null=carregando, true/false
  const [senha, setSenha] = useState("");
  const [conf, setConf] = useState("");
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    validarReset(token).then((r) => setValido(!!r.data?.valido)).catch(() => setValido(false));
  }, [token]);

  const salvar = async () => {
    setErro("");
    if (senha.length < 6) return setErro("A senha deve ter ao menos 6 caracteres.");
    if (senha !== conf) return setErro("As senhas não conferem.");
    setBusy(true);
    try {
      await redefinirSenha(token, senha);
      setOk(true);
    } catch (e) {
      setErro(e?.response?.data?.mensagem || "Não foi possível redefinir. Solicite um novo link.");
    } finally { setBusy(false); }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default", display: "flex", alignItems: "center" }}>
      <Container maxWidth="xs">
        <Paper sx={{ p: 3 }}>
          <Stack alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <Avatar sx={{ bgcolor: "primary.main" }}><LockResetIcon /></Avatar>
            <Typography variant="h6">Redefinir senha</Typography>
          </Stack>

          {valido === null ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}><CircularProgress /></Box>
          ) : ok ? (
            <Stack spacing={2}>
              <Alert severity="success">Senha redefinida com sucesso! Você já pode fazer login com a nova senha.</Alert>
              <Button variant="contained" onClick={() => navigate("/eventos")}>Ir para o início</Button>
            </Stack>
          ) : !valido ? (
            <Alert severity="error">Link inválido ou expirado. Solicite uma nova redefinição na tela de login.</Alert>
          ) : (
            <Stack spacing={2}>
              {erro && <Alert severity="error">{erro}</Alert>}
              <TextField type="password" label="Nova senha" value={senha} onChange={(e) => setSenha(e.target.value)} />
              <TextField type="password" label="Confirmar nova senha" value={conf} onChange={(e) => setConf(e.target.value)} onKeyDown={(e) => e.key === "Enter" && salvar()} />
              <Button variant="contained" size="large" onClick={salvar} disabled={busy} sx={{ py: 1.2 }}>
                {busy ? "Salvando…" : "Redefinir senha"}
              </Button>
            </Stack>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
